import { createContractRequest } from './helper';
export const postOffersCalculate = createContractRequest({
    route: '/contract/offers/calculate',
    method: 'post',
    source: 'data',
});
